<div class="offer-bottom-popup">

  <ion-card>

    <ion-card-header>
      <div class="ion-text-right close-icon">
        <ion-icon (click)="close(false)" name="close-outline"></ion-icon>
      </div>
      <div class="ion-text-center title">{{subscribe.title}}<span
          *ngIf="subscribe.coloredtitle != ''">{{subscribe.coloredtitle}}</span></div>
      <div class="ion-text-center quote">“{{subscribe.quote}}”</div>
    </ion-card-header>

    <ion-card-content>
      <!-- in case header of bullets exists -->
      <!-- <ion-row>
        <ion-col class="header-of-bullet">
          Updating Diet Plan
        </ion-col>
      </ion-row> -->

      <ion-row *ngIf="subscribe.dataTitle && subscribe.dataTitle != ''">
        <ion-col>
          <span class="subbullets">{{subscribe.dataTitle}}</span>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ul class="ion-text-left ion-margin-start bullets margin-bottm-0">
            <li [ngClass]="{'padding-top-5': subscribe.dataTitle && subscribe.dataTitle != ''}" *ngFor="let bullet of subscribe.bullets">
              {{bullet.title}}
              <ul *ngIf="bullet.subpoints" class="subbullets">
                <li *ngFor="let points of bullet.subpoints">{{points}}</li>
              </ul>
            </li>
          </ul>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="subscribe.dataLastText && subscribe.dataLastText != ''">
        <ion-col>
          <span class="subbullets">{{subscribe.dataLastText}}</span>
        </ion-col>
      </ion-row>

      <ion-row class="ion-text-center banner" *ngIf="subscribe.isGauge">
        <ion-col>
          
        </ion-col>
        <ion-col>
          <div>
            <rg-gauge-chart [canvasWidth]="canvasWidth" [needleValue]="needleValue" [options]="options">
            </rg-gauge-chart>
          </div>
        </ion-col>
        <ion-col>
          
        </ion-col>
      </ion-row>

      <ion-row class="ion-text-center banner" *ngIf="!subscribe.isGauge">
        <ion-col>
          <img [src]="subscribe.img">
        </ion-col>
      </ion-row>

      <div *ngIf="isOfferActive" [ngStyle]="{'margin-top': subscribe.dataLastText && subscribe.dataLastText != '' ? '-25px' : ''}">
        <ion-row class=" ion-text-center">
          <ion-col class="offer-plan" *ngIf="country == 'IND'">
            {{plan?.perid}} Months Plan <span class="color-gold">₹</span><span class="strike">{{plan?.amount}}</span><span class="color-gold"> {{plan?.discountedAmount}}</span>
          </ion-col>
          <ion-col class="offer-plan" *ngIf="country != 'IND'">
            {{plan?.perid}} Months Plan <span class="color-gold">$</span> <span class="strike">{{plan?.message4}}</span><span class="color-gold"> {{plan?.dollarPrice}}</span>
          </ion-col>
        </ion-row>
  
        <ion-row class="ion-text-center">
          <ion-col class="popular-plan">
            Special offer valid only for today
          </ion-col>
        </ion-row>

        <ion-row class="ion-text-center" style="font-size: 1.5rem;">
          <ion-col class="ion-text-right">
            <b style="color: #01A3A4;">{{countdownMins}}</b>
          </ion-col>
          <ion-col size="1.5">
            <b style="color: #01A3A4;">:</b>
          </ion-col>
          <ion-col class="ion-text-left">
            <b style="color: #01A3A4;">{{countdownSec}}</b>
          </ion-col>
        </ion-row>
        <ion-row class="ion-text-center">
          <ion-col class="ion-text-right">
            <span>MIN</span>
          </ion-col>
          <ion-col size="1.5">
           
          </ion-col>
          <ion-col class="ion-text-left">
            <span>SEC</span>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="!isOfferActive" [ngStyle]="{'margin-top': subscribe.dataLastText && subscribe.dataLastText != '' ? '-25px' : ''}">
        <ion-row class=" ion-text-center">
          <ion-col class="offer-plan" *ngIf="country == 'IND'">
            {{plan?.perid}} Months Plan <span class="color-gold">₹</span><span class="color-gold"> {{plan?.discountedAmount}}</span>
          </ion-col>
          <ion-col class="offer-plan" *ngIf="country != 'IND'">
            {{plan?.perid}} Months Plan <span class="color-gold">$</span><span class="color-gold"> {{plan?.dollarPrice}}</span>
          </ion-col>
        </ion-row>
  
        <ion-row class="ion-text-center">
          <ion-col class="popular-plan">
            Most popular plan
          </ion-col>
        </ion-row>
      </div>

      <ion-row class="ion-text-center ion-padding-bottom" (click)="doUpgrade()">
        <ion-col>
          <ion-button class="subscribe-offer" expand="block" shape="round">
            Subscribe
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row class="ion-text-center margin-vertical-5" (click)="goToUpgrade()">
        <ion-col class="view-all-plan">
          {{subscribe.viewAll}}
        </ion-col>
      </ion-row>

    </ion-card-content>
  </ion-card>
</div>